import React, { useState } from 'react';
import {
  Row, Col,
  Divider,
  Button,
  Form, Input,
  InputNumber
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined,
} from '@ant-design/icons';
// import { MasterContext } from '../../App';
import './style';

export default React.forwardRef((props, ref) => {
  // const { surface, unit } = useContext(MasterContext);
  const { spec, onCloseCallback, onSaveCallback } = props;
  const [form] = Form.useForm();
  const [name, setName] = useState(spec ? spec.name : undefined);
  const [size, setSize] = useState(spec ? spec.size : undefined);
  const [weight, setWeight] = useState(spec ? spec.weight : undefined);
  // const [unitId, setUnitId] = useState(spec ? spec.unit_id : undefined);
  // const [surfaceId, setSurfaceId] = useState(spec ? spec.surface_id : undefined);
  const onSave = async () => {
    try {
      const values = await form.validateFields();
      console.log('onSave:', values);
      if (onSaveCallback) {
        onSaveCallback(values);
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const initValue = [
    { name: ['id'], value: spec ? spec.id : undefined },
    { name: ['name'], value: name },
    { name: ['weight'], value: weight },
    { name: ['size'], value: size },
    // { name: ['surface_id'], value: surfaceId },
    // { name: ['unit_id'], value: unitId },
  ];

  return (
    <Form form={form} style={{ padding: '1rem' }} onFinish={onSave} fields={initValue} >
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
          <Form.Item label="　产品号" name="name" rules={[{ required: true, message: '请输入产品号!' }]}>
            <Input autoComplete="off" onChange={(e) => setName(e.target.value)} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="产品尺寸" name="size" rules={[{ required: true, message: '请输入产品尺寸!' }]}>
            <Input autoComplete="off" onChange={(e) => setSize(e.target.value)} />
          </Form.Item>
        </Col>
      </Row>
      {/* <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="表面处理" name="surface_id" rules={[{ required: true, message: '请选择表面处理!' }]}>
            <Select
              onChange={(value) => setSurfaceId(value)}
              showSearch="true"
              placeholder="请选择产品表面处理"
              style={{ width: '100%' }}
            >
              {surface.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row> */}
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="产品重量" name="weight" rules={[{ required: true, message: '请输入重量!' }]}>
            <InputNumber autoComplete="off" onChange={(value) => setWeight(value)} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>
      {/* <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item label="计量单位" name="unit_id" rules={[{ required: true, message: '请输入重量!' }]}>
            <Select
              onChange={(value) => setUnitId(value)}
              showSearch="true"
              placeholder="请选择产品计量单位"
              style={{ width: '100%' }}
            >
              {unit.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name_cn} - {item.name_en}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row> */}
      <Divider />
      <Row justify="end">
        <Col justify="end" span={24}>
          <div style={{ padding: '0 1rem', width: '100%', display: 'flex', justifyContent: 'right' }}>
            <div style={{ marginLeft: 'auto' }}></div>
            <Button onClick={onCloseCallback} icon={<CloseOutlined />}>关 闭</Button>
                  &nbsp;&nbsp;
            <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>确 定</Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
});
